import { render, staticRenderFns } from "./SidebarEditContact.vue?vue&type=template&id=397cf1a7&"
import script from "./SidebarEditContact.vue?vue&type=script&lang=js&"
export * from "./SidebarEditContact.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEditContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports